import * as actions from './actions';
import * as selectors from './selectors';
import * as model from './model';
import reducer from './reducer';

export { actions, selectors, model };
export default reducer;
